"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBorderElementDestinationBase = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("../../../../core/model/borders/enums");
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var open_xml_color_import_helper_1 = require("../../color/open-xml-color-import-helper");
var destination_1 = require("../destination");
var TableBorderElementDestinationBase = (function (_super) {
    tslib_1.__extends(TableBorderElementDestinationBase, _super);
    function TableBorderElementDestinationBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TableBorderElementDestinationBase.prototype, "border", {
        get: function () { return this.desc.getProp(this.properties); },
        enumerable: false,
        configurable: true
    });
    TableBorderElementDestinationBase.prototype.getColor = function (reader) {
        return this.data.documentModel.cache.colorModelInfoCache.getItem(open_xml_color_import_helper_1.OpenXmlColorImportHelper.createColorModelInfo(this.data, reader, 'color'));
    };
    TableBorderElementDestinationBase.prototype.setBorderOffset = function (space) {
        this.border.offset = unit_converter_1.UnitConverter.pointsToTwips(space);
        this.properties.setValue(this.desc, this.border);
    };
    TableBorderElementDestinationBase.prototype.setBorderWidth = function (size) {
        this.border.width = Math.round(unit_converter_1.UnitConverter.pointsToTwipsF(size * 0.125));
        this.properties.setValue(this.desc, this.border);
    };
    TableBorderElementDestinationBase.prototype.setBorderLineStyle = function (borderLineStyle) {
        this.border.style = borderLineStyle == enums_1.BorderLineStyle.Nil ? enums_1.BorderLineStyle.None : borderLineStyle;
        this.properties.setValue(this.desc, this.border);
    };
    return TableBorderElementDestinationBase;
}(destination_1.LeafSetMaskedPropertyDestination));
exports.TableBorderElementDestinationBase = TableBorderElementDestinationBase;
